import React, { useState, useRef, useEffect } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { default as AvatarIcon } from '../../../Icons/Avatar';
import s from './BasicUserAvatar.scss';
var MAX_PIXELATED_RESOLUTION = 50;
function isSmallGifImage(img) {
    var imgExtension = img.src.split('?').shift();
    if (!imgExtension) {
        return false;
    }
    imgExtension = imgExtension.split('.').pop();
    return (imgExtension === 'gif' &&
        img.naturalHeight <= MAX_PIXELATED_RESOLUTION &&
        img.naturalWidth <= MAX_PIXELATED_RESOLUTION);
}
export var BasicUserAvatar = function (_a) {
    var _b = _a.user, username = _b.username, usericon = _b.usericon, usericonDefault = _b.usericonDefault, type = _b.type;
    var t = useTranslation().t;
    var _c = useState(false), shouldBePixelated = _c[0], setPixelated = _c[1];
    var imgRef = useRef(null);
    var isGroup = type && type.includes('group');
    var showDefaultAvatar = !isGroup && (usericonDefault || !usericon);
    useEffect(function () {
        var img = imgRef.current;
        if (!img || !isSmallGifImage(img)) {
            return;
        }
        setPixelated(true);
    }, []);
    if (showDefaultAvatar) {
        return (React.createElement("div", { className: s['default-avatar'] },
            React.createElement(AvatarIcon, { className: s['avatar-icon'], customSizable: true })));
    }
    return (React.createElement("img", { alt: t('avatar.alt', {
            username: username || t('avatar.unknownUser'),
        }), className: classnames(s['user-avatar'], shouldBePixelated && s['pixelated']), ref: imgRef, src: usericon }));
};
BasicUserAvatar.displayName = 'BasicUserAvatar';
export default BasicUserAvatar;
//# sourceMappingURL=BasicUserAvatar.js.map